import LockScreenView from "./LockScreenView"
export default LockScreenView
